module.exports = __webpack_public_path__ + "img/minting_screenshot.4e1595e0.png";